import type { DashboardPopularProduct } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { formatCount } from '@/shared/lib';
import { ContentCard, EmptyState, tableStyles } from '@/shared/ui';

interface DashboardPopularProductsProps {
  readonly items: readonly DashboardPopularProduct[];
}

const percent = (rate: number | null): string =>
  rate === null ? '–' : `${Math.round(rate * 100)}%`;
const quantity = (value: number | null): string =>
  value === null ? '–' : `${formatCount(Math.round(value))}개`;

/** 인기 상품 상위 5 — 기간 안 견적 요청 수 기준. 발행 전환은 요청 중 견적서가 발행된 비율. 상품명이 상품 편집으로 간다. */
export const DashboardPopularProductsWidget = ({
  items,
}: DashboardPopularProductsProps): ReactElement => (
  <ContentCard title="인기 상품" description="기간 안 견적 요청이 많은 순입니다.">
    {items.length === 0 ? (
      <EmptyState>기간 안 견적 요청이 없습니다.</EmptyState>
    ) : (
      <div className="overflow-x-auto">
        <table className={tableStyles.table}>
          <thead className={tableStyles.head}>
            <tr>
              <th className={tableStyles.th}>순위</th>
              <th className={tableStyles.th}>상품</th>
              <th className={`${tableStyles.th} text-right`}>견적 요청</th>
              <th className={`${tableStyles.th} text-right`}>발행 전환</th>
              <th className={`${tableStyles.th} text-right`}>평균 수량</th>
              <th className={`${tableStyles.th} text-right`}>결제 주문</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={item.productId} className={tableStyles.row}>
                <td className={`${tableStyles.td} tabular-nums text-muted-foreground`}>
                  {index + 1}
                </td>
                <td className={tableStyles.td}>
                  <Link
                    to={`/products/editor/${item.productId}`}
                    className="font-semibold underline underline-offset-4 hover:no-underline"
                  >
                    {item.productName}
                  </Link>
                </td>
                <td className={`${tableStyles.td} text-right tabular-nums`}>
                  {formatCount(item.quoteRequests)}건
                </td>
                <td className={`${tableStyles.td} text-right tabular-nums`}>
                  {percent(item.issuedRate)}
                </td>
                <td className={`${tableStyles.td} text-right tabular-nums`}>
                  {quantity(item.averageQuantity)}
                </td>
                <td className={`${tableStyles.td} text-right tabular-nums`}>
                  {formatCount(item.paidOrders)}건
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </ContentCard>
);
